<template>
    <v-layout
        row
        wrap
        class="prospective-member__list-item"
        v-if="localProspect">
        <v-flex
            xs12
            sm5
            md5>
            <v-flex class="prospective-member__list-item__user">
                <v-list two-line>
                    <v-list-tile>
                        <v-list-tile-avatar>
                            <img :src="localProspect.profileImageUrl" :onerror="imageErrorFallback(localProspect)" :data-qe-id="`lead_profile_image_${sequence}`">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title :data-qe-id="`lead_name_${sequence}`">{{localProspect.firstName}} {{localProspect.lastName}}</v-list-tile-title>
                            <v-list-tile-sub-title :title="`${localProspect.chapterName} | ${localProspect.regionName}`" :data-qe-id="`lead_chaptername_${i}`">{{ localProspect.chapterName }} | {{localProspect.regionName}}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-flex>
        </v-flex>
        <v-flex
            class="prospective-member__list-item__view"
            xs6
            sm4
            md4
            text-sm-center>
            <v-flex
                tag="span"
                v-if="!isWaiverVisible(sequence)"
                :data-qe-id="`region_view_waiver_${sequence}`">{{chapterWaiverConstants.VIEW_WAIVER}}</v-flex>
            <v-flex
                tag="span"
                v-if="isWaiverVisible(sequence)"
                :data-qe-id="`region_close_waiver_${sequence}`">{{chapterWaiverConstants.CLOSE_WAIVER}}</v-flex>
            <i class="fas fa-chevron-down" :data-qe-id="`btn_waiver_visible_down_${sequence}`" v-if="!isWaiverVisible(sequence)" @click="toggleWaiver(sequence, localProspect.id)"></i>
            <i class="fas fa-chevron-up" :data-qe-id="`btn_waiver_visible_up_${sequence}`" v-if="isWaiverVisible(sequence)" @click="toggleWaiver(sequence, localProspect.id)"></i>
        </v-flex>
        <v-flex
            xs6
            sm3
            md3
            text-xs-right
            text-sm-right
            class="prospective-member__list-item__comment_btn"
            v-if="isRegionalOfficer">
            <v-btn
                class="primary_btn small"
                :disabled="disableCommentButton(localProspect.waiverFlowStatus) || showPrint"
                :data-qe-id="`btn_comment_waiver_${sequence}`"
                @click="showReasonDialogBox(localProspect.id)">{{appCommonConstants.COMMENT}}</v-btn>
        </v-flex>
        <v-flex
            class="prospective-member__list-item__btns"
            xs6
            sm3
            md3
            text-xs-right
            text-sm-right
            v-if="waiverStatus[sequence] !== chapterWaiverConstants.APPROVED && waiverStatus[sequence] !== chapterWaiverConstants.DENIED && isPanelMember">
            <v-btn
                v-if="!isPRPMemberStatus(localProspect.waiverFlowStatus)"
                class="primary_btn transparent small"
                @click="denyOrApproveWaiver(sequence, localProspect.id, chapterWaiverConstants.DENY)"
                :data-qe-id="`prp_member_deny_${sequence}`">{{chapterWaiverConstants.DENY}}</v-btn>
            <v-btn
                v-if="!isPRPMemberStatus(localProspect.waiverFlowStatus)"
                class="primary_btn small"
                @click="denyOrApproveWaiver(sequence, localProspect.id, chapterWaiverConstants.APPROVED)"
                :data-qe-id="`prp_member_approve_${sequence}`">{{chapterWaiverConstants.WAIVER_APPROVE}}</v-btn>
            <p
                :class="setColor(localProspect.waiverFlowStatus)"
                v-if="isPRPMemberStatus(localProspect.waiverFlowStatus)"
                :data-qe-id="`waiver_status_${sequence}`"> {{getWaiverFlowStatus(localProspect.waiverFlowStatus)}} </p>
        </v-flex>

        <v-flex
            class="prospective-member__loading"
            v-if="getInProgress"
            justify-center
            text-xs-center>
            <v-progress-circular indeterminate color="grey"></v-progress-circular>
        </v-flex>
        <v-flex px-5 py-3 class="view-wavier active" xs12 v-if="waiverDetails && isWaiverVisible(sequence)">
            <v-flex v-if="isPanelMember || isPRPMemberForm" class="form-control">
                <v-flex>{{waiverFormConstants.RECOMMENDATION}}</v-flex>
                <v-flex class="char-count">{{recommendationLength}} {{waiverFormConstants.OF}} {{waiverFormConstants.MAX_RECOMMENDATION_LENGTH}} {{waiverFormConstants.CHARACTERS}}</v-flex>
                <v-textarea
                    auto-grow
                    solo
                    data-qe-id="txt_recommendation"
                    v-model="localProspect.recommendation"
                    readonly>
                </v-textarea>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.TYPE_OF_WAIVER}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-flex font-italic tag="small">{{waiverFormConstants.TYPE_OF_WAIVER_WATER_MARK}}</v-flex>
                <v-autocomplete
                    attach
                    :items="waiverTypes"
                    item-text="type"
                    item-value="type"
                    v-model="localProspect.typeOfWaiver"
                    data-qe-id="select_form_waiver_typeOfWaiver"
                    readonly></v-autocomplete>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.AGE}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-text-field
                    :value="localProspect.age"
                    data-qe-id="txt_age"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.DOB}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-flex>
                    <v-menu
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        :disabled="true"
                        full-width
                        min-width="290px"
                        max-width="290px">
                        <v-text-field
                            slot="activator"
                            id="birth_date_input_waiver"
                            data-qe-id="txt_waiver_DOB"
                            v-model="commonFormBirthDate"
                            :disabled="true"
                            required
                            solo
                            readonly></v-text-field>
                        <v-date-picker
                            ref="picker"
                            @input="menu=false"
                            v-model="commonFormISOBirthDate"
                            :readonly="true"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1900-01-01"></v-date-picker>
                    </v-menu>
                </v-flex>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.COMPANY_NAME}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-text-field
                    :value="localProspect.companyName"
                    data-qe-id="txt_company"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.TYPE_OF_COMPANY}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-text-field
                    :value="waiverDetails.typeOfCompany"
                    data-qe-id="txt_company_type"
                    solo
                    readonly></v-text-field>
            </v-flex>
             <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.WHO_DO_YOU_REPORT_TO}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-text-field
                    :value="waiverDetails.whoDoYouReportTo"
                    data-qe-id="txt_who_do_you_report_to"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex v-if="isPanelMember || isPRPMemberForm" class="form-control">
                <v-flex tag="span">{{waiverFormConstants.REGION_NAME}}</v-flex>
                <v-text-field
                    :value="waiverDetails.regionName"
                    data-qe-id="txt_region_name"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex class="form-control link">
                <v-flex tag="span">{{waiverFormConstants.COMPANY_WEBSITE}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-text-field
                    :value="localProspect.companyWebsite"
                    data-qe-id="txt_company_website"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.TITLE}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-autocomplete
                    attach
                    :items="titleTypes"
                    item-text="type"
                    item-value="type"
                    v-model="localProspect.title"
                    data-qe-id="select_form_waiver_title"
                    readonly
                    ></v-autocomplete>
            </v-flex>
            <v-flex class="form-control" v-if="localProspect.title && localProspect.title.toLowerCase() === waiverFormConstants.OTHER">
                <v-flex tag="span">{{waiverFormConstants.TITLE_OTHER}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-text-field
                    :value="localProspect.titleOther"
                    data-qe-id="txt_title_other"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.NO_OF_EMPLOYEES}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-flex font-italic tag="small">{{waiverFormConstants.NO_OF_EMPLOYEES_WATER_MARK}}</v-flex>
                <v-text-field
                    :value="localProspect.numberOfEmployees"
                    data-qe-id="txt_employee_count"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex class="form-control" v-if="localProspect.numberOfEmployees < 50">
                <v-flex tag="span">{{waiverFormConstants.TOTAL_EMPLOYEE_COMP}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-text-field
                    :value="localProspect.totalCompensation"
                    data-qe-id="txt_compensation"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.CORP_TYPE}}</v-flex>
                <v-text-field
                    :value="localProspect.corporationType"
                    data-qe-id="txt_corp_type"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.DOLLAR_VALUE}}</v-flex>
                <v-text-field
                    :value="localProspect.dollarVolume"
                    data-qe-id="txt_dollar_volume"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.ENTERPRISE_VALUE}}
                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                </v-flex>
                <v-text-field
                    readonly
                    solo
                    :value="localProspect.enterpriseValue"
                    data-qe-id="txt_form_waiver_enterpriseValue"></v-text-field>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.MANAGEMENT_RESEARCH}}</v-flex>
                <v-text-field
                    :value="localProspect.managementResearch"
                    data-qe-id="txt_mgm_research"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.NO_OF_MEMBERS_IN_CHAPTER}}</v-flex>
                <v-text-field
                    :value="waiverDetails.chapterMembersCount"
                    data-qe-id="txt_chapter_members"
                    solo
                    readonly></v-text-field>
            </v-flex>
            <v-flex tag="h1">
                {{waiverFormConstants.FORM_TEXT1}}
                <v-flex tag="span" color="red">{{waiverFormConstants.FORM_TEXT2}}</v-flex> {{waiverFormConstants.FORM_TEXT3}}
            </v-flex>
            <v-flex tag="h2">{{waiverFormConstants.FORM_WARNING}}</v-flex>
            <v-flex v-if="waiverQuestions && waiverQuestions.length > 0 && waiverDetails.waiverAnswerList">
                <v-flex class="form-control">
                    <v-flex tag="span">{{waiverQuestions[0].question}}</v-flex>
                    <v-textarea
                        v-if="!isPrintForm"
                        auto-grow
                        data-qe-id="txt_form_waiver_q1"
                        :value="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[0].id).answer"
                        solo
                        readonly></v-textarea>
                        <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[0].id).answer}}
                        </v-flex>
                </v-flex>
                <v-flex class="form-control">
                    <v-flex v-if="waiverQuestions[1].question" tag="span">{{waiverQuestions[1].question.part1}} <em>{{waiverQuestions[1].question.part2}}</em>
                        {{waiverQuestions[1].question.part3}}</v-flex>
                    <v-textarea
                        v-if="!isPrintForm"
                        auto-grow
                        data-qe-id="txt_form_waiver_q2"
                        :value="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[1].id).answer"
                        solo
                        readonly></v-textarea>
                        <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[1].id).answer}}
                        </v-flex>
                </v-flex>
                <v-flex class="form-control" v-if="waiverDetails.typeOfWaiver === waiverFormConstants.AGE_TYPE">
                    <v-flex tag="span">{{waiverQuestions[2].question}}</v-flex>
                    <v-textarea
                        v-if="!isPrintForm"
                        auto-grow
                        :value="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[2].id).answer"
                        solo
                        data-qe-id="txt_form_waiver_age_q1"
                        readonly></v-textarea>
                        <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[2].id).answer}}
                        </v-flex>
                </v-flex>
                <v-flex v-if="waiverDetails.typeOfWaiver === waiverFormConstants.TITLE_TYPE">
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverQuestions[3].question}}</v-flex>
                        <v-textarea
                            v-if="!isPrintForm"
                            auto-grow
                            :value="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[3].id).answer"
                            solo
                            data-qe-id="txt_form_waiver_title_q1"
                            readonly></v-textarea>
                            <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[3].id).answer}}
                            </v-flex>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverQuestions[4].question}}</v-flex>
                        <v-textarea
                            v-if="!isPrintForm"
                            auto-grow
                            :value="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[4].id).answer"
                            solo
                            data-qe-id="txt_form_waiver_title_q2"
                            readonly></v-textarea>
                            <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[4].id).answer}}
                            </v-flex>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverQuestions[5].question}}</v-flex>
                        <v-textarea
                            v-if="!isPrintForm"
                            auto-grow
                            :value="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[5].id).answer"
                            solo
                            data-qe-id="txt_form_waiver_title_q3"
                            readonly></v-textarea>
                            <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[5].id).answer}}
                            </v-flex>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverQuestions[6].question}}</v-flex>
                        <v-textarea
                            v-if="!isPrintForm"
                            auto-grow
                            :value="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[6].id).answer"
                            solo
                            data-qe-id="txt_form_waiver_title_q4"
                            readonly></v-textarea>
                            <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[6].id).answer}}
                            </v-flex>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverQuestions[7].question}}</v-flex>
                        <v-textarea
                            v-if="!isPrintForm"
                            auto-grow
                            :value="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[7].id).answer"
                            solo
                            data-qe-id="txt_form_waiver_title_q5"
                            readonly></v-textarea>
                            <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[7].id).answer}}
                            </v-flex>
                    </v-flex>
                </v-flex>
            </v-flex>
            <v-flex class="form-control">
                <v-flex tag="span">{{waiverFormConstants.FORM_QUESTION3}} </v-flex>
                <v-textarea
                    v-if="!isPrintForm"
                    auto-grow
                    :value="localProspect.additionalComments"
                    solo
                    data-qe-id="txt_form_waiver_q3"
                    readonly></v-textarea>
                    <v-flex class="answer-text" v-if="isPrintForm"> {{localProspect.additionalComments}}
                    </v-flex>
            </v-flex>
            <v-flex class="form-control" v-if="localProspect.typeOfWaiver === waiverFormConstants.TITLE_TYPE">
                <v-flex
                    font-italic
                    tag="span"
                    class="mandatory_title">{{waiverFormConstants.FORM_QUESTION4}}</v-flex>
            </v-flex>
            <v-flex xs10 class="attach-documents">
                <file-attachment
                    leadId="localProspect.id"
                    :maxFilesToAttach="appCommonConstants.MAXIMUM_NUMBER_OF_FILE_ATTACHMENTS_WAIVER"
                    :maxFileSizeLimit="appCommonConstants.FILE_ATTACHMENT_SIZE_LIMIT"
                    :attachments="waiverDetails.attachments"
                    :viewType="chapterWaiverConstants.PRPADMIN"
                    :attachmentCallback="handleAttachedFiles"
                    :disabled="true">
                </file-attachment>
            </v-flex>
            <WaiverComments v-if="waiverDetails && waiverDetails.waiverCommentList && waiverDetails.waiverCommentList.length > 0" :waiverCommentList="waiverDetails.waiverCommentList"></WaiverComments>
            <v-flex
                text-xs-right
                xs12>
                <v-btn
                    v-if="!isPrintForm && !showPrint"
                    data-qe-id="btn_save"
                    class="primary_btn mr-0"
                    @click="saveAsPDF(waiverDetails)">
                    {{chapterWaiverConstants.SAVE_AS_PDF}}
                </v-btn>
                <v-btn
                    v-if="showPrint"
                    data-qe-id="btn_save"
                    class="primary_btn mr-0"
                    @click="printForm()">
                    {{chapterWaiverConstants.SAVE_AS_PDF}}
                </v-btn>
            </v-flex>
        </v-flex>
    </v-layout>
</template>

<script>
    import { appCommonConstants, routerNames } from "../appCommon.constants";
    import { chapterWaiverConstants, waiverFormConstants, waiverStates, printForm } from "./ChapterWaiver.constants";
    import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import FileAttachment from "../ChapterWaiver/FileAttachments";
    import WaiverComments from "./WaiverComments";
    import { getFormattedDate, getFormattedDateUTC } from "../../common/utils/dateTime";
    import moment from 'moment/src/moment';

    export default {
        name: "WaiverFormCommon",
        components: {
            FileAttachment,
            WaiverComments,
        },
        created() {
            this.$watch(() => {
                this.localProspect = this.$props.prospect;
            });
            if (this.isPrintForm) {
                this.localProspect = this.printWaiverDetails;
            }
            this.setVisibleProspect(null);
        },
        mounted() {
            if (this.isPrintForm) {
                this.toggleWaiver(this.sequence, this.localProspect.id);
            }
        },
        data: () => {
            return {
                appCommonConstants,
                chapterWaiverConstants,
                waiverFormConstants,
                menu: false,
                getInProgress: false,
                showCommentsDialogBox: false,
                showPrint: false,
                routerNames,
                waiverStates,
                localProspect: {},
            };
        },
        methods: {
            ...mapActions({
                getWaiverDetails: `chapterWaiver/${storeAction.getWaiverDetails}`,
                submitVote: `chapterWaiver/${storeAction.submitVote}`,
            }),
            ...mapMutations({
                setVisibleProspect: `chapterWaiver/${storeMutation.setVisibleProspect}`,
                resetChapterWaiverList: `chapterWaiver/${storeMutation.resetChapterWaiverList}`,
                setPrintWaiverDetails: `chapterWaiver/${storeMutation.setPrintWaiverDetails}`,
            }),
            handleAttachedFiles() {
                //Add additional attachment handling logic here.
            },
            getFormattedDate,
            getFormattedDateUTC,
            imageErrorFallback(element) {
                element.profileImageUrl = element.fallbackProfileImageUrl;
                return `this.src='${element.fallbackProfileImageUrl || ''}';this.onerror=null;`;
            },
            isWaiverVisible(index) {
                return this.visibleProspect === index;
            },
            toggleWaiver(index, leadId) {
                let viewType = this.chapterWaiverConstants.REGIONALOFFICER;
                if (this.isPanelMember === true || this.isPRPMemberForm) {
                    viewType = this.chapterWaiverConstants.PRPMEMBER;
                }
                const req = {
                    leadId,
                    viewType,
                };
                if (this.communityIdFromRoute) {
                  req.communityId = this.communityIdFromRoute;
                }
                if (this.isWaiverVisible(index)) {
                    this.setVisibleProspect(null);
                } else {
                    this.getInProgress = true;
                    this.getWaiverDetails(req).then(() => {
                        this.getInProgress = false;
                        if (this.isPrintForm) {
                            setTimeout(() => {
                                this.$nextTick(() => {
                                    this.showPrint = true;
                                    this.printForm(this.localProspect);
                                });
                            }, 1000);
                        }
                    });
                    this.setVisibleProspect(index);
                }
            },
            disableCommentButton(waiverFlowStatus) {
                if (waiverFlowStatus && waiverFlowStatus.toLowerCase() === this.chapterWaiverConstants.SEND_TO_PRP.toLowerCase()) {
                    return true;
                }
                return false;
            },
            showReasonDialogBox(leadId) {
                const req = {
                    leadId,
                    showCommentsDialogBox: true,
                };
                this.$emit("showReasonDialogBox", req);
            },
            setColor(waiverStatus) {
                return waiverStatus === this.chapterWaiverConstants.APPROVED_BY_MEMBER ? 'success-text' : 'failure-text';
            },
            isPRPMemberStatus(waiverFlowStatus) {
                return waiverFlowStatus === this.chapterWaiverConstants.APPROVED_BY_MEMBER || waiverFlowStatus === this.chapterWaiverConstants.DENIED_BY_MEMBER;
            },
            async denyOrApproveWaiver(index, leadId, status) {
                const postBody = {
                    sequence: index,
                    leadid: leadId,
                    votestatus: status,
                    showDenyDialog: true,
                };
                if (status === this.chapterWaiverConstants.APPROVED) {
                    await this.submitVote(postBody);
                } else {
                    this.deniedLeadId = leadId;
                    this.leadSequence = index;
                    this.$emit('showDenyDialogBox', postBody);
                }
            },
            getWaiverFlowStatus(waiverFlowStatus) {
                const status = this.waiverStates.filter(state => state.key === waiverFlowStatus);
                return status.length ? status[0].value : '';
            },
            saveAsPDF() {
                this.setPrintWaiverDetails(this.localProspect);
                let viewType = null;
                if (this.$route && this.$route.name === this.routerNames.PEER_REVIEW_PANEL) {
                    viewType = this.routerNames.PEER_REVIEW_PANEL;
                } else {
                    viewType = "regionalOfficer";
                }
                this.$router.push({ 
                path: '/waiverFormCommon',
                    query: {
                        view: viewType,
                    },
                });
            },
            printForm,
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                waiverQuestions: `chapterWaiver/${storeGetters.waiverQuestions}`,
                waiverTypes: `chapterWaiver/${storeGetters.waiverTypes}`,
                titleTypes: `chapterWaiver/${storeGetters.titleTypes}`,
                visibleProspect: `chapterWaiver/${storeGetters.visibleProspect}`,
                waiverDetails: `chapterWaiver/${storeGetters.waiverDetails}`,
                printWaiverDetails: `chapterWaiver/${storeGetters.printWaiverDetails}`,
                waiverStatus: `chapterWaiver/${storeGetters.memberVoteStatus}`,
            }),
            recommendationLength() {
                return this.localProspect.recommendation ? this.localProspect.recommendation.length : 0;
            },
            commonFormBirthDate() {
                if (this.commonFormISOBirthDate) {
                    return this.getFormattedDateUTC(this.commonFormISOBirthDate);
                }
                return "";
            },
            commonFormISOBirthDate: {
                get() {
                    return new Date(this.localProspect.birthdate).toISOString().substr(0, 10);
                },
                set(date) {
                    this.localProspect.birthdate = moment.utc(date);
                },
            },
            isPrintForm() {
                return this.$route && this.$route.name === this.routerNames.WAIVER_FORM_COMMON;
            },
            isPRPMemberForm() {
                return this.$route && this.$route.query && this.$route.query.view === this.routerNames.PEER_REVIEW_PANEL;
            },
            communityIdFromRoute() {
              return this.$route.params.communityId;
            },
        },
        props: {
            prospect: {
                type: Object,
                required: false,
            },
            isPanelMember: {
                type: Boolean,
                default: false,
            },
            sequence: {
                type: Number,
                required: false,
            },
            leadId: {
                type: String,
                required: false,
            },
            isRegionalOfficer: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .prospective-member {
        &__list-item {
            border-bottom: 1px solid $ypo-tile-border;
            align-items: center;

            &__view {
                font-weight: bold;

                span {
                    display: block;
                    color: $ypo-gray-text;
                    font-family: Raleway, serif;
                }

                .waiver-date {
                    color: $ypo-gray-text;
                    font-family: Raleway;
                    font-size: 12px;
                }

                i {
                    color: $ypo-cta;
                    cursor: pointer;
                }
            }

            &__btns {
                span {
                    display: inline-block;
                    text-align: center;
                    width: 50%;

                    em {
                        display: block;
                        font-style: normal;
                        font-weight: 600;
                        color: $ypo-blue;
                        font-size: 18px;
                    }
                }

            }

            .success-text {
                color: $ypo-green;
            }

            .failure-text {
                color: $ypo-red;
            }
        }

        .view-wavier {
            background-color: rgba($ypo-blue-grey, 0.3);
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 rgba($black, 0.2);
            border: 1px solid rgba($ypo-blue-grey, 0.8);
            opacity: 0;
            overflow: hidden;
            height: 0;
            transition: all 0.5s;

            &.active {
                height: auto;
                opacity: 1;
            }

            h1 {
                text-align: center;
                font-weight: 500;
                font-family: Raleway, serif;
                font-size: 22px;
                padding-left: 0;
                color: $ypo-blue;
                margin-bottom: 12px;

                span {
                    color: $ypo-red;
                }
            }

            h2 {
                padding-left: 0;
                border-bottom: 0;
                margin-bottom: 12px;
            }

            .form-control {
                span {
                    color: $ypo-cta;
                    display: block;
                }

                small {
                    color: $ypo-cta;
                    font-size: 12px;
                }

                em {
                    font-size: 12px;
                }

                .error-color {
                    color: $ypo-error-red;
                    font-weight: bold;
                }
            }

            .attach-documents {
                span {
                    color: $ypo-cta;
                    font-size: 14px;
                    text-align: center;
                    padding: 8px 20px;
                    border: 1px $ypo-cta dashed;
                    font-weight: 600;
                    cursor: pointer;
                    display: inline-block;
                    transition: 0.3s all ease;

                    &:hover {
                        background-color: $ypo-cta;
                        color: $white;
                    }

                    i {
                        margin-right: 10px;
                    }
                }
            }
        }
    }
    .answer-text {
        border-radius: 5px;
        border: 2px solid $ypo-blue-grey;  
        padding: 10px 10px 10px 10px;
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";

    .prospective-member {
        &__list-item {
            &__user {
                .theme--light.v-list {
                    background: transparent;
                }

                .v-list__tile {
                    padding: 0;
                    height: auto;
                }

                .v-list__tile__title {
                    font-weight: bold;
                    color: $ypo-cta;
                }

                .v-list__tile__sub-title {
                    font-weight: 500;
                    color: $ypo-blue !important;
                    font-family: Raleway, serif;
                    font-size: 12px;
                }
            }
        }

        .view-wavier {
            .form-control {
                .v-input {
                    margin-top: 10px;
                }

                .v-input__control {
                    min-height: inherit;
                }

                .v-input__slot {
                    background: transparent !important;
                    box-shadow: none !important;
                    padding-left: 0 !important;
                    padding-right: 0;

                    &:before {
                        border-color: rgba($black, 0.2);
                    }
                }

                input {
                    border-bottom: 1px solid rgba($black, 0.2);
                }

                .v-select__slot {
                    input {
                        border-bottom: 0;
                    }
                }

                .v-label,
                input {
                    font-size: 14px;
                    font-weight: bold;
                    color: $ypo-gray-text !important;
                }

                .v-textarea {
                    .v-input__slot {
                        border: 1px solid rgba($black, 0.2);
                        padding-left: 10px !important;
                        border-radius: 4px;
                    }
                }

                &.link {

                    .v-label,
                    input {
                        color: $ypo-cta !important;
                    }
                }

                .v-menu__content {
                    box-shadow: 0 2px 5px 0 rgba($black, 0.18);
                    border: 1.5px solid rgba($ypo-text-border, 0.25);
                    border-radius: 3px;
                    min-height: 307px;

                    .v-list {
                        background: $ypo-extra-light-gray;

                        &>div {
                            &:hover {
                                background: $ypo-cta;

                                .v-list__tile__title {
                                    color: $white;
                                }
                            }

                            .v-list__tile__title {
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
